import React, { useEffect, useState, createElement } from 'react';
import { TranslationProvider } from './hooks/useTranslations';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { BenefitsTicker } from './components/BenefitsTicker';
import { ValueProposition } from './components/ValueProposition';
import { FundingSolutions } from './components/FundingSolutions';
import { HowItWorks } from './components/HowItWorks';
import { Requirements } from './components/Requirements';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsConditions } from './components/TermsConditions';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'privacy' | 'terms'>('home');
  // Meta Pixel
  useEffect(() => {
    if ((window as any).fbq) return;
    const f = window as any;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    (window as any).fbq('init', '3244351822531038');
    (window as any).fbq('track', 'PageView');
    // noscript fallback
    const ns = document.createElement('img');
    ns.height = 1;
    ns.width = 1;
    ns.style.display = 'none';
    ns.src = 'https://www.facebook.com/tr?id=3244351822531038&ev=PageView&noscript=1';
    document.body.appendChild(ns);
  }, []);
  useEffect(() => {
    // Handle hash-based routing
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#/privacy') {
        setCurrentPage('privacy');
      } else if (hash === '#/terms') {
        setCurrentPage('terms');
      } else {
        setCurrentPage('home');
      }
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const navigateToHome = () => {
    window.location.hash = '';
    setCurrentPage('home');
    window.scrollTo(0, 0);
  };
  const navigateToPrivacy = () => {
    window.location.hash = '#/privacy';
    setCurrentPage('privacy');
    window.scrollTo(0, 0);
  };
  const navigateToTerms = () => {
    window.location.hash = '#/terms';
    setCurrentPage('terms');
    window.scrollTo(0, 0);
  };
  return <TranslationProvider data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#00E676] selection:text-white" data-id="element-1">
        {currentPage === 'home' && <>
            <Navbar data-id="element-2" />
            <main data-id="element-3">
              <Hero data-id="element-4" />
              <BenefitsTicker data-id="element-5" />
              <Requirements data-id="element-6" />
              <HowItWorks data-id="element-7" />
              <ValueProposition data-id="element-8" />
              <FundingSolutions data-id="element-9" />
              <Testimonials data-id="element-10" />

              <FAQ data-id="element-11" />
              <Contact data-id="element-12" />
            </main>
            <Footer onPrivacyClick={navigateToPrivacy} onTermsClick={navigateToTerms} data-id="element-13" />
          </>}

        {currentPage === 'privacy' && <PrivacyPolicy onBack={navigateToHome} data-id="element-14" />}
        {currentPage === 'terms' && <TermsConditions onBack={navigateToHome} data-id="element-15" />}
      </div>
    </TranslationProvider>;
}